// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';

export function getPublicIntegrationKey(merchant: Merchant): string {
  return merchant.public_key;
}
